// src/pages/WatchSelection.js
import React from 'react';
import { Link } from 'react-router-dom';
// Using Si icons as provided and Fa for general elements
import { SiApple, SiSamsung } from 'react-icons/si';
import { FaWrench, FaStopwatch } from 'react-icons/fa'; // Added FaStopwatch as a generic

// Button style for consistency
const contactLinkStyle = {
    display: 'inline-block', alignItems: 'center', background: '#6c757d', color: '#fff',
    border: '1px solid #6c757d', borderRadius: '4px', padding: '0.5rem 1rem',
    cursor: 'pointer', fontSize: '0.9rem', textDecoration: 'none', fontWeight: '500',
    transition: 'background-color 0.2s, border-color 0.2s', marginLeft: '4px',
};

// --- Brand Data ---
// Using Si icons as requested. Note the 'iwatch' path for Apple.
const watchBrands = [
    { name: 'Apple Watch', path: '/watch/iwatch', Icon: SiApple, ariaLabel: 'Select Apple Watch' },
    { name: 'Samsung Watch', path: '/watch/samsung', Icon: SiSamsung, ariaLabel: 'Select Samsung Galaxy Watch' },
    // Consider adding a generic 'Other' or specific brands if needed
    // { name: 'Other Brands', path: '/contact', Icon: FaStopwatch, ariaLabel: 'Contact us for other watch brands' },
];
// --- ---

function WatchSelection() {
  return (
    <main className="page-container watch-selection-page" style={{ padding: '2rem 1rem' }}>
      <header style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '2rem', color: '#212529', marginBottom: '0.5rem' }}>Select Your Watch Brand</h1>
        <p style={{ fontSize: '1.1rem', color: '#6c757d' }}>Choose your smartwatch brand to view repair options.</p>
      </header>

      {/* Grid for selecting brand */}
      {/* className="watch-grid" needs CSS for grid layout */}
      <div className="watch-grid" style={gridStyle}>
        {watchBrands.map((brand) => (
          <Link
            key={brand.name}
            to={brand.path}
            className="watch-item" // Needs CSS
            style={watchItemStyle} // Basic inline styles
            title={`View ${brand.name} Models`}
            role="button"
            aria-label={brand.ariaLabel}
          >
            <div className="watch-logo" style={logoContainerStyle}>
              {/* Render Si icon with Kentech medium gray color */}
              <brand.Icon size={50} style={{ color: '#6c757d' }} />
            </div>
            <h3 style={itemHeadingStyle}>{brand.name}</h3>
            <span style={itemTextStyle}>View Models & Repairs</span>
          </Link>
        ))}
      </div>

      {/* Additional Info Section */}
      <section className="watch-extra-info" style={extraInfoStyle} aria-labelledby="watch-info-heading">
        <h4 id="watch-info-heading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem' }}>
          <FaWrench />
          Fast Watch Repairs!
        </h4>
        <p>
            Whether it’s a cracked screen, battery issue, or water damage, our certified technicians can bring your watch back to life quickly. All repairs come with a 3-month warranty!
        </p>
        <p style={{ marginTop: '1.5rem' }}>
          Have a different watch brand?{' '}
          <Link to="/contact" style={contactLinkStyle}>
            Contact us
          </Link>
          {' '}for more information.
        </p>
      </section>
    </main>
  );
}

// --- Inline Styles (Shared styles) ---
const gridStyle = { display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '2rem', marginBottom: '3rem', };
const watchItemStyle = { display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '1.5rem', border: '1px solid #dee2e6', borderRadius: '8px', textDecoration: 'none', color: '#495057', minWidth: '200px', textAlign: 'center', transition: 'transform 0.2s ease, box-shadow 0.2s ease', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', backgroundColor: '#fff', };
const logoContainerStyle = { marginBottom: '1rem', height: '50px', display: 'flex', alignItems: 'center', };
const itemHeadingStyle = { margin: '0.5rem 0', fontSize: '1.2rem', color: '#212529', };
const itemTextStyle = { fontSize: '0.9rem', color: '#6c757d', };
const extraInfoStyle = { marginTop: '3rem', padding: '2rem', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '8px', textAlign: 'center', maxWidth: '650px', marginLeft: 'auto', marginRight: 'auto', color: '#495057', };
// --- ---

export default WatchSelection;